exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/_wks-ext.js
// module id = LO75
// module chunks = 0